import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { msalInstance } from "./auth/AuthProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));

msalInstance
    .initialize()
    .then(() => {
        const cachedAccounts = msalInstance.getAllAccounts();
        if (cachedAccounts.length === 1) {
            msalInstance.setActiveAccount(cachedAccounts[0]);
        }

        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );
    })
    .catch((error) => {
        // eslint-disable-next-line no-console
        console.error("MSAL initialization failed:", error);
    });
